import WorkoutPage from './WorkoutPage/WorkoutPage'
import DailyWorkoutPage from './DailyWorkoutPage/DailyWorkoutPage'
import WeeklyWorkoutPage from './WeeklyWorkoutPage/WeeklyWorkoutPage'
import ResultsPage from './ResultsPage/ResultsPage'
import ProfilePage from './ProfilePage/ProfilePage'
import PlansPage from './PlansPage/PlansPage'
import PlanSubscriptionPage from './PlanSubscriptionPage/PlanSubscriptionPage'
import UserWeightPage from './UserWeightPage/UserWeightPage'
import UserDataPage from './UserDataPage/UserDataPage'
import UserChallengePage from './UserChallengePage/UserChallengePage'
import UserBiometricPage from './UserBiometricPage/UserBiometricPage'
import UserBillingPage from './UserBillingPage/UserBillingPage'
import UserPaymentsPage from './UserPaymentsPage/UserPaymentsPage'
import UserPasswordPage from './UserPasswordPage/UserPasswordPage'

export {
	WorkoutPage,
	DailyWorkoutPage,
	WeeklyWorkoutPage,
	ResultsPage,
	ProfilePage,
	PlansPage,
	PlanSubscriptionPage,
	UserWeightPage,
	UserDataPage,
	UserChallengePage,
	UserBiometricPage,
	UserBillingPage,
	UserPaymentsPage,
	UserPasswordPage
}



// WEBPACK FOOTER //
// ./src/client/webapp/pages/index.js